import React from 'react';

import './header2.css';


const Header2 = () => {
  
  return (
    
       <section id="home" className='section_header'>
        
            <div className="container header2_main">
                <div className="header2-content">
                  <div className='header2-text-wrapper animation-wrapper'>

                                 <h1 className='title1 animation-wrapper1'>
                                  <div>Building the Efficient</div>
                                  <div>and Post-Quantum Secure</div>
                                  <div>Digital Infrastructures</div>
                                  </h1> 


                                  <h1 className='title2 animation-wrapper2'>
                                  <div>Quantum-Era Cryptographic</div>
                                  <div>Computation by HW-SW Co-design </div>
                                  </h1> 

                       
                      </div>
                  
                    
                </div> 
                
             
            </div>
          
           
              
        </section>
   
  )
}

export default Header2
